var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup14413(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.732,
    height: 24.891,
    viewBox: "0 0 24.732 24.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14413",
    "data-name": "Group 14413",
    transform: "translate(-3.554 -3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14412",
    "data-name": "Group 14412",
    transform: "translate(3.554 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23324",
    "data-name": "Path 23324",
    d: "M19.342,16.453l-.381-.625a.732.732,0,0,0,.167,1.326Zm-6.842,0,.214.7a.732.732,0,0,0,.167-1.326ZM4.3,26.2l-.726-.09Zm23.247,0,.727-.09ZM21.777,10.821a5.853,5.853,0,0,1-2.816,5.007l.761,1.251a7.317,7.317,0,0,0,3.519-6.258ZM15.92,4.964a5.857,5.857,0,0,1,5.857,5.857h1.464A7.321,7.321,0,0,0,15.92,3.5Zm-5.857,5.857A5.857,5.857,0,0,1,15.92,4.964V3.5A7.321,7.321,0,0,0,8.6,10.821Zm2.816,5.007a5.853,5.853,0,0,1-2.816-5.007H8.6a7.317,7.317,0,0,0,3.519,6.258Zm-.594-.075A12.458,12.458,0,0,0,3.571,26.107l1.453.181a10.994,10.994,0,0,1,7.689-9.135ZM3.571,26.107a2.066,2.066,0,0,0,2.1,2.284V26.927a.6.6,0,0,1-.647-.639Zm2.1,2.284h20.5V26.927H5.671Zm20.5,0a2.066,2.066,0,0,0,2.1-2.284l-1.453.181a.6.6,0,0,1-.647.639Zm2.1-2.284a12.458,12.458,0,0,0-8.715-10.355l-.427,1.4a10.994,10.994,0,0,1,7.689,9.135Z",
    transform: "translate(-3.554 -3.5)",
    fill: "#642d92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14413);
export default __webpack_public_path__ + "static/media/Group 14413.5e64838fa865f2126c69b03972f88e9c.svg";
export { ForwardRef as ReactComponent };